module.exports = __webpack_public_path__ + "img/djdown.4b8fb7cc.svg";